export function setSocketSuccess(socket){
  return {
    type: '@socket/SET_SOCKET_SUCCESS',
    payload: {socket}
  };
}